module.exports = __webpack_public_path__ + "img/21_29.9e8b351a.png";